import * as Styles from './styles';
import Image from 'next/image';
import sendSegmentEvent from 'utils/segment';
import {
    SegmentEventNameTypes,
    SegmentEventActionTypes,
} from 'utils/segment/constants';
import { getEditActionName } from './utils';

const DetailsCard = ({
    data,
    showEditInfo = true,
    userDetails,
    isMobile,
}: {
    data: any;
    showEditInfo: boolean;
    userDetails: any;
    isMobile: boolean;
}) => {
    const { src } = data;

    const onEditInfoClickHandler = () => {
        const actionName = getEditActionName(data.id);
        sendSegmentEvent(
            SegmentEventNameTypes.ACTION,
            {
                action_type: SegmentEventActionTypes.TAP_BTN,
                action_name: actionName,
            },
            { userDetails, isMobile }
        );

        return data.header?.link();
    };
    return (
        <Styles.Wrapper>
            <Styles.HeaderContainer>
                <Styles.Heading>
                    <Styles.ImageContainer>
                        {/* prettier-ignore */}
                        <Image width={'24px'} height={'24px'} alt={''} src={src} />
                    </Styles.ImageContainer>
                    {data.header.heading}
                </Styles.Heading>
                {showEditInfo && (
                    <Styles.Link onClick={onEditInfoClickHandler}>
                        Edit info
                    </Styles.Link>
                )}
            </Styles.HeaderContainer>
            <Styles.BodyContainer>
                {data.body.map((data) => {
                    return (
                        <Styles.Row key={data.label}>
                            <Styles.Label>{data.label}</Styles.Label>
                            <Styles.Value>{data.value}</Styles.Value>
                        </Styles.Row>
                    );
                })}
            </Styles.BodyContainer>
        </Styles.Wrapper>
    );
};
export default DetailsCard;
